import { render, staticRenderFns } from "./Consultations.vue?vue&type=template&id=5ada803c&scoped=true&"
import script from "./Consultations.vue?vue&type=script&lang=js&"
export * from "./Consultations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ada803c",
  null
  
)

export default component.exports